var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"15px","width":"100%"}},[(_vm.index == 0)?_c('div',[_c('span',{staticClass:"el-icon-top"}),_vm._v("上拉加载更多")]):(_vm.index == 1)?_c('div',[_c('span',{staticClass:"el-icon-loading"}),_vm._v("\n    正在加载中...\n  ")]):(_vm.index == 2)?_c('div',[_vm._v("\n    没有更多数据了\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15fb9219","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BottomLoading.vue
// module id = null
// module chunks = 